import styled from 'styled-components';

export const StyledSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m}px;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;

/*
 * These head their sections ("Live now", "Publishing will change"), so they are the
 * heading — not an eyebrow decorating one. Uppercase with tracking is reserved for status
 * badges in this system; as a group heading it only shouted. Now the Label role.
 */
export const StyledSectionLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const StyledChangeList = styled.ul`
  margin: 0;
  padding-left: ${({ theme }) => theme.spacing.m}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs}px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
`;
